import { render, staticRenderFns } from "./doughnut-chart.html?vue&type=template&id=32f4a1de&scoped=true&"
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./doughnut-chart.scss?vue&type=style&index=0&id=32f4a1de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4a1de",
  null
  
)

export default component.exports